import { makeStyles } from 'tss-react/mui'
import Img from 'src/assets/images/campaigns/download.jpg'
import { nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    margin: theme.spacing(4, 0, 20),
    height: 'auto',
    backgroundImage: `url(${Img?.src})`,
    backgroundRepeat: 'no-repeat',
    borderRadius: '60px',
    backgroundPosition: 'center',
    backgroundSize: '100% 100%',
    padding: theme.spacing(9, 8, 1, 8),
    [theme.breakpoints.down('sm')]: {
      borderRadius: '40px',
      backgroundSize: 'cover',
      padding: theme.spacing(7.3, 5, 0.1, 5),
    },
  },
  minHeight: {
    minHeight: '500px',
  },

  zenMode: {
    backgroundImage: 'none',
    border: '1px solid black',
  },
  boxOne: {
    // minHeight: "350px",

    background: 'white',
    padding: theme.spacing(8, 7, 5, 7),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '40px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 5, 5, 5),
      borderRadius: '24px',
    },
  },
  boxTwo: {
    background: 'black',
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: ' normal',
    fontWeight: '800',
    fontSize: '48px',
    lineHeight: '64px',
    textTransform: 'uppercase',
    color: '#000000',
    textAlign: 'start',
    '@media (max-width:1315px)': {
      fontSize: '40px',
    },
    '@media (max-width:1135px)': {
      fontSize: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      width: '100%',
      lineHeight: 'normal',
    },
  },
  titleBoxTwo: {
    color: 'white',
  },

  desc: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: ' normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '26px',
    color: '#000000',
    textAlign: 'start',
    padding: theme.spacing(1, 0, 6),
    opacity: '0.7',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: 'normal',
    },
  },

  descBoxTwo: {
    color: '#FFFFFF',
    opacity: '0.7',
  },
  // btnContainer: {
  //   width: '100%',

  //   display: 'flex',
  //   justifyContent: 'end',
  //   alignItems: 'center',
  //   [theme.breakpoints.down('md')]: {
  //     justifyContent: 'start',
  //   },
  //   [theme.breakpoints.down('xs')]: {
  //     justifyContent: 'start',
  //   },
  // },
  cardsBtn: {
    width: '100%',

    background: 'black',
    color: 'white',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },

  cardsBtnBoxTwo: {
    width: '100%',

    background: 'white',
    color: 'black',
    '&:hover': {
      border: '1px solid white',
      background: 'black',
      color: 'white',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },
}))

export default useStyles
